import React from 'react';
import { Inbox } from 'lucide-react';

// Trạng thái trống trong thẻ trắng (icon tròn 48px + chữ muted), theo màn AdQuangCao.
const AdminEmpty = ({ children, icon }: { children: React.ReactNode; icon?: React.ReactNode }) => (
  <section className="adm-card" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 12, padding: '48px 20px' }}>
    <span
      aria-hidden="true"
      style={{ width: 48, height: 48, borderRadius: '50%', background: 'var(--adm-fill)', color: 'var(--adm-muted)', display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }}
    >
      {icon || <Inbox size={22} />}
    </span>
    <p style={{ margin: 0, fontSize: 14, fontWeight: 600, color: 'var(--adm-muted)' }}>{children}</p>
  </section>
);

export default AdminEmpty;
